<div [style.display]="isVisible() ? 'block' : 'none'" class="signature-item-wrapper">
  <div [id]="htmlId()" class="signature-wrapper">
    <div class="signature-text" [ngClass]="[properties.style.toLowerCase(), 'preserve-newlines']" [style]="textStyle()">
      {{ properties.text }}
    </div>

    @if (properties.groupItems.length) {
      <div class="signature-user-role">{{ properties.groupItems.join(' / ') }}</div>
    }

    @if (!hasValue()) {
      <button
        [disabled]="!canSign() || formControl?.disabled"
        type="button"
        role="button"
        class="signature-opener"
        (click)="onSignatureOpenClick($event)">
        <div class="icon-safe-zone">
          <svg class="icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
            <path
              d="M563-491q73-54 114-118.5T718-738q0-32-10.5-47T679-800q-47 0-83 79.5T560-541q0 14 .5 26.5T563-491ZM120-120v-80h80v80h-80Zm160 0v-80h80v80h-80Zm160 0v-80h80v80h-80Zm160 0v-80h80v80h-80Zm160 0v-80h80v80h-80ZM136-280l-56-56 64-64-64-64 56-56 64 64 64-64 56 56-64 64 64 64-56 56-64-64-64 64Zm482-40q-30 0-55-11.5T520-369q-25 14-51.5 25T414-322l-28-75q28-10 53.5-21.5T489-443q-5-22-7.5-48t-2.5-56q0-144 57-238.5T679-880q52 0 85 38.5T797-734q0 86-54.5 170T591-413q7 7 14.5 10.5T621-399q26 0 60.5-33t62.5-87l73 34q-7 17-11 41t1 42q10-5 23.5-17t27.5-30l63 49q-26 36-60 58t-63 22q-21 0-37.5-12.5T733-371q-28 25-57 38t-58 13Z" />
          </svg>
        </div>
        <span>{{ properties.label }}</span>
      </button>
    }

    @if (hasValue()) {
      <div class="signature-result">
        <div class="signature-user-result">
          @if (!formControl?.disabled) {
            <button class="control" type="button" role="button" (click)="resetSignature()">
              <div class="icon">
                <mat-icon>delete</mat-icon>
              </div>
            </button>
          }
          <div class="signature-user">{{ signatureInfo() }}</div>
        </div>

        <div class="signature-image-result">
          <img [src]="dataUrl()" alt="Signature" width="620" height="280" />
        </div>
      </div>
    }
  </div>
</div>
